module.exports = __webpack_public_path__ + "static/media/101.020b96f1.png";